var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2094_3740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9425 1.9425C10.6575 1.6575 10.275 1.5 9.8775 1.5H4.5C3.675 1.5 3 2.175 3 3V15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V6.6225C15 6.225 14.8425 5.8425 14.5575 5.565L10.9425 1.9425ZM11.25 12H9.75V13.5C9.75 13.9125 9.4125 14.25 9 14.25C8.5875 14.25 8.25 13.9125 8.25 13.5V12H6.75C6.3375 12 6 11.6625 6 11.25C6 10.8375 6.3375 10.5 6.75 10.5H8.25V9C8.25 8.5875 8.5875 8.25 9 8.25C9.4125 8.25 9.75 8.5875 9.75 9V10.5H11.25C11.6625 10.5 12 10.8375 12 11.25C12 11.6625 11.6625 12 11.25 12ZM9.75 6V2.625L13.875 6.75H10.5C10.0875 6.75 9.75 6.4125 9.75 6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2094_3740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateletter);
export default __webpack_public_path__ + "static/media/generate letter.67f9fc7855d0ca8708035517b1fd532b.svg";
export { ForwardRef as ReactComponent };